module.exports = __webpack_public_path__ + "static/media/cafeteria.fe1fe12a.jpg";